// extracted by mini-css-extract-plugin
export default {"wrapper":"Kca-z","play":"Lca-z"};